<template>
  <v-container
      id="grid"
      fluid
      grid-list-sm
      tag="section"
    >
    <v-layout row wrap>
      <v-flex d-flex xs12 order-xs5>
        <v-layout column>
          <v-flex>
            <v-card flat>
              <v-card-text>
                <p><b>Status: </b> {{ $t(`actived.${subscription.actived}`) }}</p>
                <p><b>Valor: </b> {{ $n((subscription.amount/100), 'currency') }}</p>
                <p><b>Cartão: </b> {{ subscription.pan }}</p>
                <p><b>Bandeira: </b> {{ subscription.scheme }}</p>
                <p><b>À cada: </b> {{ subscription.range_size }} {{ setRange(subscription.range_type) }}</p>
                <p><b>Vencimento: </b> {{ setDateFormat(subscription.due_date) }}</p>
                <p><b>Último Pagamento: </b> {{ setDateFormat(subscription.last) }}</p>
                <p><b>Próximo Pagamento: </b> {{ setDateFormat(subscription.next) }}</p>
                <p><b>Válido até: </b> {{ setDateFormat(subscription.final_date) }}</p>
                <p><b>Total de Pagamentos: </b> {{ subscription.total_payments }}</p>
                </v-card-text>
            </v-card>
          </v-flex>
          <v-data-table flat
            :headers="headers"
            :items="subscription.payments"
            class="elevation-2"
            :total-items="subscription.total_payments"
            click:row
          >
            <template slot="items" slot-scope="props">
              <td class="text-xs-left">{{ props.item.id }}</td>
              <td class="text-xs-left">{{ props.item.uuid }}</td>
              <td class="text-xs-left">{{ $n((props.item.amount), 'currency') }}</td>
              <td class="text-xs-left">{{ setDateFormat(props.item.due_date) }}</td>
              <td class="text-xs-left">{{ $t(`status.${props.item.status}`) }}</td>
            </template>
          </v-data-table>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';

export default {
  name: 'SubscriptionContent',
  data() {
    return {
      items: [],
      headers: [
        { text: 'ID' },
        { text: 'UUID' },
        { text: 'Valor' },
        { text: 'Data' },
        { text: 'Status' },
      ],
    };
  },
  computed: {
    ...mapGetters({
      subscription: 'invoices/subscription',
    }),
  },
  methods: {
    ...mapActions({

    }),
    setClass(status) {
      return `subscription ${status}`;
    },
    setChipColor(color) {
      return this.$t(`colors.${color}`);
    },
    paymentType: (type) => {
      if (type === true) {
        return 'credit';
      }
      return 'debit';
    },
    getDate(date) {
      return moment(date);
    },
    setDateFormat(date) {
      if (date === null) {
        return ''
      } else {
        return new Date(date).toLocaleDateString("pt-BR")
      }
    },
    setRange(kind) {
      if (kind == 'yearly') {
        return 'Ano(s)'
      } else if (kind == 'daily') {
          return 'Dia(s)'
      } else {
        return 'Mês(s)'
      }
    }
  },
};
</script>
